import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow} from "react-google-maps"
import {connect} from 'react-redux'
import {compose, withProps} from 'recompose'
import SearchBox from 'react-google-maps/lib/components/places/SearchBox'
import { withStyles } from 'material-ui/styles';
import {path} from 'ramda'
import GileadeMarker from './GileadeMarker'
import {isAuthenticated} from '../Redux/appRedux'
import gileadeGlobalConfig from '../gileadeGlobalConfig'
import {getExternalParams} from '../Services/externalParams'

const styles = {
  search: {
    boxSizing: `border-box`,
    border: `1px solid transparent`,
    width: `240px`,
    height: `32px`,
    marginTop: `27px`,
    padding: `0 12px`,
    borderRadius: `3px`,
    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
    fontSize: `14px`,
    outline: `none`,
    textOverflow: `ellipses`,
    marginTop: '50px',
    marginLeft: '-105px'
  }
}

const hideAllMapStyle = [{
  featureType: "road",
  elementType: "labels",
  stylers: [
    { visibility: "off" }
  ]
}]

const {mapaLatitude, mapaLongitude, mapaZoom} = getExternalParams() 
const externalInitialLatLng = mapaLatitude && mapaLongitude ? 
  {lat: mapaLatitude, lng: mapaLongitude} : null

class GileadeMap extends React.Component {
  state = {
    bounds: null,
    center: externalInitialLatLng || gileadeGlobalConfig.initialLatlng,
    defaultZoom: mapaZoom || gileadeGlobalConfig.initialZoom,
    markers: [],
    currentCelula: null
  }


  componentWillMount() {
    this.google = window.google
    this.hideAllMapStyle =  new this.google.maps.StyledMapType(hideAllMapStyle, { name: 'Hide All Style' })
  }

  selectCelula = id => {
    if (this.state.currentCelula === id) {
      this.setState({currentCelula: null})
      return 
    }
    this.setState({currentCelula: id})
  }

  componentWillReceiveProps() {
    this.setState({currentCelula: null})
  }

  onBoundsChanged = () => {
    this.setState({
      bounds: this.map.getBounds(),
      center: this.map.getCenter(),
    })
  }
  onPlacesChanged = () => {
    const places = this.refs.searchBox.getPlaces()
    const bounds = new this.google.maps.LatLngBounds()

    places.forEach(place => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport)
      } else {
        bounds.extend(place.geometry.location)
      }
    })
    const nextMarkers = places.map(place => ({
      position: place.geometry.location,
    }))
    const nextCenter = path([nextMarkers, 0, 'position'], this.state.center)

    this.setState({
      center: nextCenter,
      markers: nextMarkers,
    });
    this.refs.map.fitBounds(bounds);
  }


  render() {
    const {celulas, search, classes, loading, isAuthenticated} = this.props
    const {center, bounds, markers, currentCelula, defaultZoom} = this.state
    if (loading) {
      return null
    }
    return (
      <GoogleMap
        ref='map'
        defaultZoom={defaultZoom}
        defaultExtraMapTypes={[
          ['hideAll', this.hideAllMapStyle]
        ]}
        mapTypeId={isAuthenticated ? undefined : 'hideAll'}
        defaultCenter={center} >
        <SearchBox
          ref='searchBox'
          bounds={bounds}
          controlPosition={this.google.maps.ControlPosition.TOP_LEFT}
          onPlacesChanged={this.onPlacesChanged}>
          <input
            type="text"
            placeholder="Encontrar um local"
            className={classes.search} />
        </SearchBox>
        {
          celulas.map(celula => (
            <GileadeMarker 
              key={celula.id} 
              onClick={() => this.selectCelula(celula.id)}
              onClose={() => this.selectCelula(null)}
              isOpen={currentCelula === celula.id}
              celula={celula}/>
          ))
        }
        {
          markers.map(({position}, index) => (
            <Marker
              key={index}
              position={position}/>
          ))
        }
      </GoogleMap>
    )
  }
}

const mapStateToProps = state => ({
  celulas: state.celula.filtered,
  loading: state.app.loading,
  isAuthenticated: isAuthenticated(state)
})

export default compose(
  connect(mapStateToProps),
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyDrdgG-VwxnevLQgnyFl4MqOYll2cuzHws",
    loadingElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `580px` }} />
  }),
  withScriptjs,
  withGoogleMap,
  withStyles(styles)
)(GileadeMap)




// WEBPACK FOOTER //
// ./src/Components/GileadeMap.js